import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import Orders from "./Pages/Orders/Orders";
import Flowers from "./Pages/Orders/Flowers/Flowers";
import Greenery from "./Pages/Orders/Greenery/Greenery";
import Plants from "./Pages/Orders/Plants/Plants";
import DriedFlowers from "./Pages/Orders/DriedFlowers/DriedFlowers";
import Accessories from "./Pages/Orders/Accessories/Accessories";
import FloralTools from "./Pages/Orders/FloralTools/FloralTools";
import ErrorPage from "./Pages/Error/ErrorPage";
import OrderForm from "./Components/OrderForm";
import OrderConfirmation from "./Components/OrderConfirmation";
import OrderResult from "./Components/OrderResult";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/orders",
    element: <Orders />,
    children: [
      { path: "flowers", element: <Flowers /> },
      { path: "greenery", element: <Greenery /> },
      { path: "plants", element: <Plants /> },
      { path: "driedFlowers", element: <DriedFlowers /> },
      { path: "accessories", element: <Accessories /> },
      { path: "floralTools", element: <FloralTools /> },
      { path: "form", element: <OrderForm /> },
      { path: "review", element: <OrderConfirmation /> },
      { path: "result", element: <OrderResult /> },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
